import React from 'react'
import CountDownTimer, {
  CountDownTimerSettings,
} from 'Event/Dashboard/components/CountDownTimer'
import EditableCountDownTimer, {
  CountDownTimerContainer,
} from 'Event/Dashboard/components/CountDownTimer/EditableCountDownTimer'
import {useEditMode} from 'Event/EditModeProvider'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'

type CountDownTimerProps = {
  id: string
  countDownTimer: CountDownTimerSettings
  index: number
  onRender?: () => void
}

export default React.memo((props: CountDownTimerProps) => {
  const isEditMode = useEditMode()
  const {countDownTimers, localization} = useNiftyFiftyTemplate()

  const countDownTimer = (
    <CountDownTimer
      {...props.countDownTimer}
      id={props.id}
      onRender={props.onRender}
    />
  )

  if (!isEditMode) {
    return <CountDownTimerContainer>{countDownTimer}</CountDownTimerContainer>
  }

  return (
    <EditableCountDownTimer
      id={props.id}
      countDownTimer={props.countDownTimer}
      index={props.index}
      keyPath={`countDownTimers.${props.id}`}
      countDownTimers={countDownTimers}
      localization={localization}
    >
      {countDownTimer}
    </EditableCountDownTimer>
  )
})
